module.exports = __webpack_public_path__ + "img/Group 944one.16c65500.svg";